import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import { clock } from "clock";
var OtEventInfo = /** @class */ (function (_super) {
    tslib_1.__extends(OtEventInfo, _super);
    function OtEventInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clock = clock;
        _this.isAttendeesVisible = false;
        return _this;
    }
    Object.defineProperty(OtEventInfo.prototype, "currentEvent", {
        get: function () {
            return this.eventStatus.currentEvent;
        },
        enumerable: true,
        configurable: true
    });
    OtEventInfo.prototype.toggleAttendees = function () {
        if (this.currentEvent.attendees.length)
            this.isAttendeesVisible = !this.isAttendeesVisible;
    };
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], OtEventInfo.prototype, "eventStatus", void 0);
    OtEventInfo = tslib_1.__decorate([
        Component
    ], OtEventInfo);
    return OtEventInfo;
}(Vue));
export default OtEventInfo;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/OtEventInfo.vue
// module id = 221
// module chunks = 0